import { InvitationsService } from '@/service'
import Model from './Model'
export enum InvitationType {
    EMAIL = 'EMAIL',
    LINK = 'LINK'

}
export interface IInvitations {
    _id?: string
    locationId: string
    invitationDetails: Object
    invitationType: InvitationType
    groupId: string
    createdBy: string
    inviteeName: string
}
export default class Invitations extends Model {
    constructor(payload: IInvitations) {
        super(payload, InvitationsService)
    }

    set id(_id: string) {
        this._data._id = _id
    }

    get id(): string {
        return this._data._id
    }

    get locationId(): string {
        return this._data.locationId
    }

    set locationId(locationId: string) {
        this._data.locationId = locationId
    }

    get invitationDetails(): Object {
        return this._data.invitationDetails
    }

    set invitationDetails(invitationDetails: Object) {
        this._data.invitationDetails = invitationDetails
    }

    get invitationType(): InvitationType {
        return this._data.invitationType
    }

    set groupId(groupId: string) {
        this._data.groupId = groupId
    }

    get groupId(): string {
        return this._data.groupId
    }

    get createdBy(): string {
        return this._data.createdBy
    }

    set createdBy(createdBy: string) {
        this._data.createdBy = createdBy
    }

    get inviteeName(): string {
        return this._data.inviteeName
    }

    set inviteeName(inviteeName: string) {
        this._data.inviteeName = inviteeName
    }
}